import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { User } from 'gql/graphql';
import { gql } from 'graphql-request';
import { i18n } from 'i18n-config';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = object;
type TData = string;

export const useLocaleMutation = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query currentUser {
      currentUser {
        locale
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: async (input: TVariables = {}): Promise<TData> => {
      const response = (await client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      })) as User;

      return response?.locale ?? i18n.defaultLocale;
    },
    ...options
  });
};
